// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "email-verification-result": lazy(
    () => import("@/screens/email-verification-result")
  ),
  login: lazy(() => import("@/screens/login")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-request": lazy(
    () => import("@/screens/reset-password-request")
  ),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success")
  ),
  signup: lazy(() => import("@/screens/signup")),
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
